module.exports = __webpack_public_path__ + "img/footer-bottom-logo-1.f9bf1fed.png";